import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RecordType } from '../../types';
import * as replayStats from '../replayStats';
export function createSegment(_ref) {
  var context = _ref.context,
    creationReason = _ref.creationReason,
    encoder = _ref.encoder;
  var encodedBytesCount = 0;
  var viewId = context.view.id;
  var metadata = _objectSpread({
    start: Infinity,
    end: -Infinity,
    creation_reason: creationReason,
    records_count: 0,
    has_full_snapshot: false,
    index_in_view: replayStats.getSegmentsCount(viewId),
    source: 'browser'
  }, context);
  replayStats.addSegment(viewId);
  function addRecord(record, callback) {
    metadata.start = Math.min(metadata.start, record.timestamp);
    metadata.end = Math.max(metadata.end, record.timestamp);
    metadata.records_count += 1;
    metadata.has_full_snapshot || (metadata.has_full_snapshot = record.type === RecordType.FullSnapshot);
    var prefix = encoder.isEmpty ? '{"records":[' : ',';
    encoder.write(prefix + JSON.stringify(record), function (additionalEncodedBytesCount) {
      encodedBytesCount += additionalEncodedBytesCount;
      callback(encodedBytesCount);
    });
  }
  function flush(callback) {
    if (encoder.isEmpty) {
      throw new Error('Empty segment flushed');
    }
    encoder.write("],".concat(JSON.stringify(metadata).slice(1), "\n"));
    encoder.finish(function (encoderResult) {
      replayStats.addWroteData(metadata.view.id, encoderResult.rawBytesCount);
      callback(metadata, encoderResult);
    });
  }
  return {
    addRecord: addRecord,
    flush: flush
  };
}